import { dateCombiner } from '../../util/DateUtil';

export default function Dates({ dates, text }) {

    let display = [];

    if (Array.isArray(dates) && dates.length > 1) {

        let formattedDates = dateCombiner(dates);

        for (const month in formattedDates) {
            for (const time in formattedDates[month]) {
                display.push(`${month} ${formattedDates[month][time]} at ${time}`);
            }
        }

    } else if (dates && dates.length === 1) {
        display.push(new Date(dates[0]).toDateString());
    }

    return (
    <div className="d-flex align-items-center">
        <i className="ti-calendar text-primary icon-md mr-2" />
        <div className="text-top">
            <h6 className="mb-0">{text}</h6>
            {display.map((d, i) => (
                <p key={i} className="mb-0">{d}</p>
            ))}
        </div>
    </div>
);
}